import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import translations from './translations';
import './UserInfoForm.css';
import axios from 'axios';

function UserInfoForm() {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const useruuid = searchParams.get('useruuid') || '';
  const defaultLang = searchParams.get('defaultLang') || 'zh-CN';
  const evaluation_uuid = searchParams.get('evaluation_uuid') || ''; // ✅ 新增讀取 evaluation_uuid
  const isNewCandidate = searchParams.get('is_new') === 'true';

  const t = translations[defaultLang] || translations['zh-TW'];
  // const API_BASE_URL = 'http://localhost:7000';
  const API_BASE_URL = 'https://tpesapi3.properson.cn';
  //const API_BASE_URL = 'https://tpesapi.properson.net';
  const accessToken = 'a148stydfIOIUkdkfpx-1264893-asdfe8xh4l-123256ldkxLKHNC';
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  
  // 表单数据状态
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    birthYear: '',
    gender: ''
  });
  
  // 表单验证错误状态
  const [formErrors, setFormErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    // 在组件初始化时清除localStorage中可能存在的旧的公司相关参数
    const existingUserInfo = localStorage.getItem('userInfo');
    if (existingUserInfo) {
      const userInfo = JSON.parse(existingUserInfo);
      delete userInfo.companyCode;
      delete userInfo.Job_NID;
      delete userInfo.codeType;
      localStorage.setItem('userInfo', JSON.stringify(userInfo));
    }


    
    async function fetchUserInfo() {
      if (isNewCandidate) {
        setShowForm(true);
        setLoading(false);
        return;
      }

      if (!useruuid) {
        setError(t.userNotFound || 'user not found');
        setLoading(false);
        return;
      }

      // 首先验证 useruuid 是否有效
      try {
        const res = await fetch(`${API_BASE_URL}/api/assessment/userinfo/${useruuid}/`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
          },
        });
        
        const contentType = res.headers.get('content-type') || '';
        if (res.ok && contentType.includes('application/json')) {
          // useruuid 有效，无论是否有evaluation_uuid都需要检查测评状态
          await checkExistingEvaluation();
        } else {
          const raw = await res.text();
          setError(t.userNotFound || '找不到使用者，請確認連結是否正確');
          setLoading(false);
        }
      } catch (err) {
        setError(t.userNotFound || '連線失敗或使用者不存在');
        setLoading(false);
      }
    }

    // 检查是否已存在完成的测评记录
    async function checkExistingEvaluation() {
      try {
        // 从URL参数中获取evaluation_uuid和useruuid
        const urlParams = new URLSearchParams(window.location.search);
        const evaluationUuid = urlParams.get('evaluation_uuid');
        const userUuid = urlParams.get('useruuid');
        
        // 只有当有evaluation_uuid和useruuid时才检查测评状态
        if (evaluationUuid && userUuid) {
          const statusResponse = await axios.get(`${API_BASE_URL}/api/assessment/evaluation_status`, {
            params: {
              useruuid: userUuid,
              evaluation_uuid: evaluationUuid
            },
            headers: {
              Authorization: `Bearer ${accessToken}`,
              'Content-Type': 'application/json',
            },
          });
          
          if (statusResponse.status === 200) {
            const status = statusResponse.data.status;
            
            if (status === 'complete') {
              setError('您已经完成过此测评，无法重复进行。如有疑问，请联系管理员。');
              setLoading(false);
              return;
            } else if (status === 'start' || status === 'create') {
              const urlParams2 = new URLSearchParams(window.location.search);
              const companyCode2 = urlParams2.get('companyCode') || '';
              const jobNID2 = urlParams2.get('Job_NID') || '';
              const codeType2 = urlParams2.get('codeType') || '';
              const evaluationType2 = urlParams2.get('evaluation_type') || '';
              const userInfo = { useruuid, defaultLang, evaluation_uuid };
              localStorage.setItem('userInfo', JSON.stringify(userInfo));
              const existingSessions2 = localStorage.getItem('userEvaluationSessions') || '{}';
              const sessions2 = JSON.parse(existingSessions2);
              const orderKey2 = `quizOrder_${defaultLang}`;
              let existingAnswers2 = {};
              try { existingAnswers2 = JSON.parse(localStorage.getItem('quizAnswers') || '{}'); } catch { existingAnswers2 = {}; }
              const hasExistingAnswers2 = Object.keys(existingAnswers2).length > 0;
              const prev2 = sessions2[useruuid];
              const changed2 = !!prev2 && (prev2.companyCode !== companyCode2 || prev2.Job_NID !== jobNID2 || prev2.codeType !== codeType2 || prev2.evaluation_type !== evaluationType2);
              if (hasExistingAnswers2 && changed2) {
                localStorage.removeItem('quizAnswers');
                localStorage.removeItem(orderKey2);
                localStorage.removeItem('startTime');
                localStorage.removeItem('timeTaken');
                sessions2[useruuid] = { evaluation_uuid, companyCode: companyCode2, Job_NID: jobNID2, codeType: codeType2, evaluation_type: evaluationType2, userInfo: prev2?.userInfo, createdAt: new Date().toISOString() };
                localStorage.setItem('userEvaluationSessions', JSON.stringify(sessions2));
                navigate(`/intro?defaultLang=${defaultLang}`);
                setLoading(false);
                return;
              }
              sessions2[useruuid] = { evaluation_uuid, companyCode: companyCode2, Job_NID: jobNID2, codeType: codeType2, evaluation_type: evaluationType2, userInfo: prev2?.userInfo, createdAt: new Date().toISOString() };
              localStorage.setItem('userEvaluationSessions', JSON.stringify(sessions2));
              navigate(`/intro?defaultLang=${defaultLang}`);
              setLoading(false);
              return;
            }
          }
        }
        
        // 如果API没有找到记录，检查localStorage中是否有未完成的测评会话
        const existingSessions = localStorage.getItem('userEvaluationSessions');
        if (existingSessions) {
          const sessions = JSON.parse(existingSessions);
          if (sessions[useruuid]) {
            const userSession = sessions[useruuid];
            
            // 再次检查该会话的状态
            try {
              const sessionStatusResponse = await axios.get(`${API_BASE_URL}/api/assessment/evaluation_status`, {
                params: {
                  useruuid: useruuid,
                  evaluation_uuid: userSession.evaluation_uuid
                },
                headers: {
                  Authorization: `Bearer ${accessToken}`,
                  'Content-Type': 'application/json',
                },
              });
              
              if (sessionStatusResponse.status === 200) {
                const sessionStatus = sessionStatusResponse.data.status;
                
                if (sessionStatus === 'complete') {
                  setError('您已经完成过此测评，无法重复进行。如有疑问，请联系管理员。');
                  setLoading(false);
                  return;
                } else if (sessionStatus === 'start' || sessionStatus === 'create') {
                  const urlParams3 = new URLSearchParams(window.location.search);
                  const companyCode3 = urlParams3.get('companyCode') || '';
                  const jobNID3 = urlParams3.get('Job_NID') || '';
                  const codeType3 = urlParams3.get('codeType') || '';
                  const evaluationType3 = urlParams3.get('evaluation_type') || '';
                  const userInfo = { useruuid, defaultLang, evaluation_uuid: userSession.evaluation_uuid, ...userSession.userInfo };
                  localStorage.setItem('userInfo', JSON.stringify(userInfo));
                  const orderKey3 = `quizOrder_${defaultLang}`;
                  let existingAnswers3 = {};
                  try { existingAnswers3 = JSON.parse(localStorage.getItem('quizAnswers') || '{}'); } catch { existingAnswers3 = {}; }
                  const hasExistingAnswers3 = Object.keys(existingAnswers3).length > 0;
                  const prev3 = sessions[useruuid];
                  const changed3 = !!prev3 && (prev3.companyCode !== companyCode3 || prev3.Job_NID !== jobNID3 || prev3.codeType !== codeType3 || prev3.evaluation_type !== evaluationType3);
                  if (hasExistingAnswers3 && changed3) {
                    localStorage.removeItem('quizAnswers');
                    localStorage.removeItem(orderKey3);
                    localStorage.removeItem('startTime');
                    localStorage.removeItem('timeTaken');
                    sessions[useruuid] = { evaluation_uuid: userSession.evaluation_uuid, companyCode: companyCode3, Job_NID: jobNID3, codeType: codeType3, evaluation_type: evaluationType3, userInfo: userSession.userInfo, createdAt: new Date().toISOString() };
                    localStorage.setItem('userEvaluationSessions', JSON.stringify(sessions));
                    navigate(`/intro?defaultLang=${defaultLang}`);
                    setLoading(false);
                    return;
                  }
                  sessions[useruuid] = { evaluation_uuid: userSession.evaluation_uuid, companyCode: companyCode3, Job_NID: jobNID3, codeType: codeType3, evaluation_type: evaluationType3, userInfo: userSession.userInfo, createdAt: new Date().toISOString() };
                  localStorage.setItem('userEvaluationSessions', JSON.stringify(sessions));
                  navigate(`/intro?defaultLang=${defaultLang}`);
                  setLoading(false);
                  return;
                }
              }
            } catch (sessionError) {
              delete sessions[useruuid];
              localStorage.setItem('userEvaluationSessions', JSON.stringify(sessions));
            }
          }
        }

        const urlParamsX = new URLSearchParams(window.location.search);
        const companyCodeX = urlParamsX.get('companyCode') || '';
        const jobNIDX = urlParamsX.get('Job_NID') || '';
        const codeTypeX = urlParamsX.get('codeType') || '';
        const evaluationTypeX = urlParamsX.get('evaluation_type') || '';
        let sessionsX;
        try { sessionsX = JSON.parse(localStorage.getItem('userEvaluationSessions') || '{}'); } catch { sessionsX = {}; }
        let existingAnswersX = {};
        try { existingAnswersX = JSON.parse(localStorage.getItem('quizAnswers') || '{}'); } catch { existingAnswersX = {}; }
        const hasExistingAnswersX = Object.keys(existingAnswersX).length > 0;

        if (useruuid && hasExistingAnswersX) {
          const prevX = sessionsX[useruuid];
        const changedX = !!prevX && (prevX.companyCode !== companyCodeX || prevX.Job_NID !== jobNIDX || prevX.codeType !== codeTypeX || prevX.evaluation_type !== evaluationTypeX);
          const orderKeyX = `quizOrder_${defaultLang}`;

          if (changedX) {
            localStorage.removeItem('quizAnswers');
            localStorage.removeItem(orderKeyX);
            localStorage.removeItem('startTime');
            localStorage.removeItem('timeTaken');
            sessionsX[useruuid] = { companyCode: companyCodeX, Job_NID: jobNIDX, codeType: codeTypeX, evaluation_type: evaluationTypeX };
            localStorage.setItem('userEvaluationSessions', JSON.stringify(sessionsX));
            setShowForm(true);
            setLoading(false);
            return;
          } else {
            sessionsX[useruuid] = { companyCode: companyCodeX, Job_NID: jobNIDX, codeType: codeTypeX, evaluation_type: evaluationTypeX };
            localStorage.setItem('userEvaluationSessions', JSON.stringify(sessionsX));
            navigate(`/intro?defaultLang=${defaultLang}`);
            return;
          }
        }

        setShowForm(true);
        setLoading(false);
      } catch (error) {
        
        // 检查是否是认证错误
        if (error.response && error.response.status === 401) {
          setError('认证失败，请检查访问权限。');
          setLoading(false);
          return;
        }
        
        // 检查是否是网络连接错误
        if (error.code === 'ECONNREFUSED' || error.message.includes('Network Error')) {
          setError('无法连接到服务器，请检查网络连接或稍后重试。');
          setLoading(false);
          return;
        }
        
        // 如果API调用失败，回退到localStorage检查
        const existingRecords = localStorage.getItem('completedEvaluations');
        if (existingRecords) {
          const completedList = JSON.parse(existingRecords);
          if (completedList.includes(useruuid)) {
            setError('您已经完成过此测评，无法重复进行。如有疑问，请联系管理员。');
            setLoading(false);
            return;
          }
        }
        setShowForm(true);
        setLoading(false);
      }
    }

    fetchUserInfo();
  }, [useruuid, defaultLang, evaluation_uuid, navigate, accessToken, API_BASE_URL, t.userNotFound]);

  // 表单输入处理
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // 清除对应字段的错误信息
    if (formErrors[name]) {
      setFormErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  // 表单验证
  const validateForm = () => {
    const errors = {};
    
    // 姓名验证（必填）
    if (!formData.name.trim()) {
      errors.name = t.nameRequired;
    }
    
    // 性别验证（必填）
    if (!formData.gender) {
      errors.gender = t.genderRequired;
    }
    
    // 出生年验证（必填）
    if (!formData.birthYear.trim()) {
      errors.birthYear = t.birthYearRequired;
    } else {
      const year = parseInt(formData.birthYear);
      const currentYear = new Date().getFullYear();
      if (isNaN(year) || year < 1900 || year > currentYear) {
        errors.birthYear = `出生年应在1900-${currentYear}之间`;
      }
    }
    
    // 邮箱验证（非必填，但如果填写了需要格式正确）
    if (formData.email.trim()) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.email)) {
        errors.email = t.emailRequired;
      }
    }
    
    // 电话验证（必填）
    if (!formData.phone || !formData.phone.trim()) {
      errors.phone = t.phoneRequired;
    }
    
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // 表单提交
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }
    
    setSubmitting(true);
    setError('');
    
    try {
      // 从 URL 参数中获取额外的参数
      const urlParams = new URLSearchParams(window.location.search);
      const companyCode = urlParams.get('companyCode');
      const jobNID = urlParams.get('Job_NID');
      const codeType = urlParams.get('codeType');
      const evaluationType = urlParams.get('evaluation_type');
      

      
      // 创建测评会话的API调用 - 使用create_evaluation_session端点
      const e_data = {
        defaultLang,
        useruuid,
        username: formData.name,
        useremail: formData.email || '',
        usersex: parseInt(formData.gender),
        year: parseInt(formData.birthYear)
      };
      
      // 添加 URL 参数到 e_data（如果存在）
      if (companyCode) {
        e_data.companyCode = companyCode;
      }
      if (jobNID) {
        e_data.Job_NID = jobNID;
      }
      if (codeType) {
        e_data.codeType = codeType;
      }
      if (evaluationType) {
        e_data.evaluation_type = evaluationType;
      }
      

      
      // 使用 create_evaluation_session 端点创建新的测评会话
      const response = await axios.post(`${API_BASE_URL}/api/assessment/create_evaluation_session`, e_data, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
      });
      
      if (response.status === 200 && response.data && response.data.evaluation_uuid) {
        // 成功创建测评会话，保存用户信息和evaluation_uuid
        // 注意：不再保存companyCode、Job_NID、codeType到localStorage，这些参数只从URL获取
        const userInfo = { 
          useruuid, 
          defaultLang, 
          evaluation_uuid: response.data.evaluation_uuid,
          name: formData.name,
          email: formData.email || '',
          phone: formData.phone || '',
          birthYear: parseInt(formData.birthYear),
          gender: parseInt(formData.gender)
        };
        
        localStorage.setItem('userInfo', JSON.stringify(userInfo));
        
        // 保存会话信息，用于下次检查
        const existingSessions = localStorage.getItem('userEvaluationSessions') || '{}';
        const sessions = JSON.parse(existingSessions);
        sessions[useruuid] = {
          evaluation_uuid: response.data.evaluation_uuid,
          companyCode: companyCode || '',
          Job_NID: jobNID || '',
          codeType: codeType || '',
          evaluation_type: evaluationType || '',
          userInfo: {
            name: formData.name,
            email: formData.email || '',
            phone: formData.phone || '',
            birthYear: parseInt(formData.birthYear),
            gender: parseInt(formData.gender)
          },
          createdAt: new Date().toISOString()
        };
        localStorage.setItem('userEvaluationSessions', JSON.stringify(sessions));
        

        
        navigate(`/intro?defaultLang=${defaultLang}`);
      } else {
        setError('创建测评会话失败，请稍后重试');
      }
    } catch (err) {
      
      // 检查是否是因为测评已存在或已完成的错误
      if (err.response && err.response.data) {
        const errorMessage = err.response.data.message || err.response.data.error || '';
        
        if (errorMessage.includes('已存在') || errorMessage.includes('已完成') || 
            errorMessage.includes('already exists') || errorMessage.includes('completed')) {
          setError('您已经完成过此测评，无法重复进行。如有疑问，请联系管理员。');
        } else {
          setError(errorMessage || '创建测评记录失败，请稍后重试');
        }
      } else {
        const errorMessage = err.message || '创建测评记录失败，请稍后重试';
        setError(errorMessage);
      }
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) return <div>{t.loading || 'loading...'}</div>;
  if (error && !showForm) return <div style={{ color: 'red', padding: '20px' }}>{error}</div>;

  // 如果需要显示表单
  if (showForm) {
    return (
      <div className="user-info-form">
        <h1>{t.title}</h1>
        <p>{t.description}</p>
        
        {error && <div style={{ color: 'red', marginBottom: '20px' }}>{error}</div>}
        
        <form onSubmit={handleSubmit} className="form-container">
          {/* 姓名 */}
          <div className="form-group">
            <label htmlFor="name">{t.name} *</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              className={`form-field ${formErrors.name ? 'is-invalid' : ''}`}
              placeholder={`${t.pleaseInput} ${t.name}`}
            />
            {formErrors.name && <div className="error-message">{formErrors.name}</div>}
          </div>
          
          {/* 性别 */}
          <div className="form-group">
            <label>{t.gender} *</label>
            <div className="gender-options">
              <label>
                <input
                  type="radio"
                  name="gender"
                  value="1"
                  checked={formData.gender === '1'}
                  onChange={handleInputChange}
                />
                {t.male}
              </label>
              <label>
                <input
                  type="radio"
                  name="gender"
                  value="0"
                  checked={formData.gender === '0'}
                  onChange={handleInputChange}
                />
                {t.female}
              </label>
            </div>
            {formErrors.gender && <div className="error-message">{formErrors.gender}</div>}
          </div>
          
          {/* 出生年 */}
          <div className="form-group">
            <label htmlFor="birthYear">{t.birthYear} *</label>
            <input
              type="number"
              id="birthYear"
              name="birthYear"
              value={formData.birthYear}
              onChange={handleInputChange}
              className={`form-field ${formErrors.birthYear ? 'is-invalid' : ''}`}
              placeholder={`${t.forExample}：1990`}
              min="1900"
              max={new Date().getFullYear()}
            />
            {formErrors.birthYear && <div className="error-message">{formErrors.birthYear}</div>}
          </div>
          
          {/* 邮箱 */}
          <div className="form-group">
            <label htmlFor="email">{t.email}</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              className={`form-field ${formErrors.email ? 'is-invalid' : ''}`}
              placeholder={`${t.pleaseInput} ${t.email}（${t.optional}）`}
            />
            {formErrors.email && <div className="error-message">{formErrors.email}</div>}
          </div>
          
          {/* 电话 */}
          <div className="form-group">
            <label htmlFor="phone">{t.phone} *</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleInputChange}
              className={`form-field ${formErrors.phone ? 'is-invalid' : ''}`}
              placeholder={`${t.pleaseInput} ${t.phone}`}
            />
            {formErrors.phone && <div className="error-message">{formErrors.phone}</div>}
          </div>
          
          <button 
            type="submit" 
            className="submit-button"
            disabled={submitting}
          >
            {submitting ? 'submitting...' : t.next}
          </button>
        </form>
      </div>
    );
  }

  return null; // 沒有 useruuid 而不顯示表單，也不跳轉
}

export default UserInfoForm;
